var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "student-list" },
    _vm._l(_vm.otherStudents, function(student) {
      return _c("student", {
        key: student.STUDENT_RID,
        attrs: { student: student, isCollapsed: _vm.isCollapsed }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }